import validator from 'validator'

export const required = value => value ? undefined : 'Required'

export const email = value => validator.isEmail(value) ? undefined : 'Not valid email adress'

export const number = value => validator.isNumeric(value) ? undefined : 'Must be a number'

export const mobilePhone = value => validator.isMobilePhone(value, ['nb-NO']) ? undefined : 'Not valid phone number'
